import { render, staticRenderFns } from "./BiotimeAreaView.vue?vue&type=template&id=0c0dd5e5&scoped=true&"
import script from "./BiotimeAreaView.vue?vue&type=script&lang=js&"
export * from "./BiotimeAreaView.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeAreaView.vue?vue&type=style&index=0&id=0c0dd5e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0dd5e5",
  null
  
)

export default component.exports